// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.ts.
import type BaseBackendService from '../BaseBackendService';
import {
  AdvisorAccess,
  AdvisorInvitation,
  CreateAdvisorInvitationRequest,
  GetAdvisorAccessResponse,
  GetAdvisorsResponse,
} from '../../models/Advisor';
export const adminBackendServiceAdvisorMixin = {
  async getAdvisorAccess(): Promise<AdvisorAccess[]> {
    return this.authApiGetAuthed(
      'admin/advisors/access',
      'Network error while fetching advisor access',
      (json: GetAdvisorAccessResponse) => json.data,
    );
  },

  async uploadFAQToBucket(prefix: string, data: any): Promise<void> {
    return this.authFetchPromise(async (token) => {
      const response = await this.authenticatedFetch(`/api/${prefix}/upload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Upload failed: ${response.status}`);
      }
    });
  },

  async setAdviseForContact(contactId: string): Promise<{
    success: boolean;
    message: string;
    data: {
      advisorContactId: string;
      advisorContactName: string;
      targetContactId: string;
      targetContactName: string;
      role: string;
    };
  }> {
    return this.authApiMutateAuthed(
      `admin/adviseFor/${contactId}`,
      'POST',
      undefined,
      (json) => json,
    );
  },

  async downloadFAQFromBucket(prefix: string): Promise<any> {
    return this.authFetchPromise(async (token) => {
      const response = await this.authenticatedFetch(`/api/${prefix}/download`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Download failed: ${response.status}`);
      }
      return response.json();
    });
  },

  async getAdvisors(): Promise<AdvisorInvitation[]> {
    return this.authApiGetAuthed(
      'admin/advisors',
      'Network error while fetching advisors',
      (json: GetAdvisorsResponse) => json.data,
    );
  },

  async clearFAQFromBucket(prefix: string): Promise<void> {
    return this.authFetchPromise(async (token) => {
      const response = await this.authenticatedFetch(`/api/${prefix}/clear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || `Clear failed: ${response.status}`);
      }
    });
  },

  async createAdvisorInvitation(
    invitationData: CreateAdvisorInvitationRequest,
  ): Promise<AdvisorInvitation> {
    return this.authApiMutateAuthed(
      'admin/advisors',
      'POST',
      invitationData,
      (json) => json.data as AdvisorInvitation,
    );
  },

  async clearImageAuthCookie(): Promise<void> {
    const response = await this.authenticatedFetch('/api/clearImageAuthCookie', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`Failed to clear image auth cookie: ${response.status}`);
    }
  },
} satisfies ThisType<BaseBackendService>;
